/**
 * Normalize Firestore `paid` on team fee line items.
 * `!!x.paid` is wrong when `paid` is the string "false" / "0" / "" (all truthy or wrong).
 */
export function feeItemMarkedPaidFromFirestore(feeData) {
  if (!feeData || typeof feeData !== 'object') return false;
  const v = feeData.paid;
  if (typeof v === 'boolean') return v;
  if (typeof v === 'number') return v !== 0;
  if (typeof v === 'string') {
    const s = v.trim().toLowerCase();
    if (s === 'true' || s === '1' || s === 'yes' || s === 'paid') return true;
    if (s === 'false' || s === '0' || s === 'no' || s === '') return false;
    return false;
  }
  if (v == null) return false;
  return Boolean(v);
}
